import { render, staticRenderFns } from "./OverdueBalancesCustomer.vue?vue&type=template&id=34fca2c2&scoped=true"
import script from "./OverdueBalancesCustomer.vue?vue&type=script&lang=js"
export * from "./OverdueBalancesCustomer.vue?vue&type=script&lang=js"
import style0 from "./OverdueBalancesCustomer.vue?vue&type=style&index=0&id=34fca2c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fca2c2",
  null
  
)

export default component.exports